module.exports = __webpack_public_path__ + "static/images/m-rig-checkbox@2x.4afcb22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/m-rig-checkbox@2x.png
// module id = uu3C
// module chunks = 6 7